import {
  Typography,
  CircularProgress,
  TableRow,
  TableCell
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { insightCSS } from 'src/content/siteAudit/WebsiteAuditDashboardcomponentes/insightcss';
import { useDispatch, useSelector } from 'react-redux';
import {
  date,
  keyword,
  keywordCompare,
  seoScore,
  siteAuditModal,
  webUrl
} from 'src/common/config/TextMessage';
import { RootState } from 'src/redux/store';
import { fifthCardCssPdf } from '../siteAuditCSS';
import RowPdf from './Row';
import {
  setFifthCardPdfCheck,
  setPdfAiMainVisibilityDetails,
  setPdfDrCount
} from 'src/redux/siteAuditReducer';
import '@progress/kendo-theme-default/dist/all.css'; // Import Kendo UI CSS
import { KeywordOverviewTableCss } from 'src/content/keywordResearch/keywordOverview/keywordOverviewCSS';
import { pdfContainerSx } from 'src/common/PdfComponents/PdfSxs';
import { timeConverter } from 'src/common/config/FunctionHelper';

/**
 * FifthCardScannedPagesPDF component is responsible for displaying scanned pages as a PDF.
 */
const FifthCardScannedPagesPDF = ({
  siteId: propSiteId,
  compare: propCompare,
  reportMetaData
}: {
  siteId?: number | string;
  compare?: string;
  reportMetaData?: any;
}) => {
  const pdfReportData = useSelector(
    (state: RootState) => state.dashboard.pdfReportData
  );

  // State to store audit site details
  const [auditSiteDetails, setAuditSiteDetails] = useState([]);
  // State to store the URL for the list view
  const [listViewUrl, setListViewUrl] = useState('');
  // State to indicate loading status
  const [loading, setLoading] = useState(true);
  // State to store filtered audit site details
  const [filteredAuditSiteDetails, setFilteredAuditSiteDetails] =
    useState(auditSiteDetails);

  // Get the site ID from Redux state
  const reduxSiteId =
    useSelector((state: RootState) => state.siteAudit.siteId) ?? 0;
  const siteId = propSiteId || reduxSiteId;
  // Get site audit details from Redux state
  let siteAuditDetailes = useSelector(
    (state: RootState) => state.siteAudit.siteAuditDetails
  );
  let reduxCompare = useSelector((state: RootState) => state.siteAudit.compare);
  const compare = propCompare !== undefined ? propCompare : reduxCompare;
  const dispatch = useDispatch();
  // Get subscription details from Redux state
  let subscriptionDetails =
    useSelector(
      (state: RootState) => state.counter.userDetails['subscription']
    ) ?? {};
  let compareDate =
    useSelector((state: RootState) => state.siteAudit?.compareDate) ?? 0;
  const currentDate = new Date().getTime();
  let userDetails: any = useSelector(
    (state: RootState) => state.counter.userDetails
  );
  useEffect(() => {
    if (pdfReportData) {
      const data = pdfReportData;
      const newData = Array.isArray(data.sitesDetail)
        ? [...data.sitesDetail]
        : [];

      if (data.DR !== undefined) {
        dispatch(setPdfDrCount(data.DR));
      }
      if (data.aiVisibilityDetails) {
        dispatch(setPdfAiMainVisibilityDetails(data.aiVisibilityDetails));
      }

      setAuditSiteDetails(newData);
      if (siteAuditDetailes?.url) {
        setListViewUrl(siteAuditDetailes.url);
      }
      setLoading(false);
      dispatch(setFifthCardPdfCheck(true));
    }
  }, [siteId, pdfReportData]);

  useEffect(() => {
    // Set filtered audit site details when the audit site details change
    setFilteredAuditSiteDetails(auditSiteDetails);
  }, [auditSiteDetails]);

  const calculatePageBreak = () => {
    if (!pdfReportData) return '';

    const { sections_visibility } = pdfReportData.config;

    const selectedSections = Object.entries(sections_visibility)
      .filter(([key, value]) => value && key !== 'graph_details')
      .map(([key, value]) => key);

    if (
      selectedSections.length <= 2 &&
      (selectedSections.includes('site_overview') ||
        selectedSections.includes('ai_visibility'))
    ) {
      return '';
    }

    return '.force-page-break';
  };

  return (
    <>
      <div
        //className="prevent-split"
        style={{
          ...fifthCardCssPdf.card,
          border: '1px solid grey'
        }}
      >
        <div style={fifthCardCssPdf.cardContent}>
          <div className="flex items-center">
            <Typography
              sx={insightCSS.headingLabel}
              style={{
                marginRight: '8px',
                fontFamily: 'Inter',
                fontWeight: 680,
                lineHeight: '14px',
                color: '#120242',
                fontSize: '24px'
              }}
            >
              {siteAuditModal.scannedPages}
            </Typography>
          </div>
          <div>
            {loading && (
              <div style={{ textAlign: 'center' }}>
                <CircularProgress size={50} />
              </div>
            )}
            {!loading && (
              <table
                className="table"
                id="pdfExport"
                style={{
                  marginTop: '25px',
                  width: '1371px !important',
                  minWidth: '1371px !important',
                  minHeight: '1371px !important'
                }}
              >
                <thead>
                  <TableRow sx={KeywordOverviewTableCss?.tableHeaderRow}>
                    <TableCell sx={{ width: '35%' }}>
                      <Typography sx={pdfContainerSx?.tableHeadText}>
                        {webUrl}
                      </Typography>
                    </TableCell>
                    <TableCell
                      sx={{
                        width: '16rem',
                        maxWidth: '16rem'
                      }}
                    >
                      <Typography sx={pdfContainerSx?.tableHeadText}>
                        {seoScore}
                      </Typography>
                    </TableCell>
                    <TableCell
                      sx={{
                        width: '16rem',
                        maxWidth: '16rem'
                      }}
                    >
                      <Typography sx={pdfContainerSx?.tableHeadText}>
                        {keyword}
                      </Typography>
                    </TableCell>
                    <TableCell
                      sx={{
                        width: '12rem',
                        maxWidth: '12rem'
                      }}
                    >
                      <Typography sx={pdfContainerSx?.tableHeadText}>
                        {keywordCompare}
                      </Typography>
                    </TableCell>
                    <TableCell
                      sx={{
                        width: '16rem',
                        maxWidth: '16rem'
                      }}
                    >
                      <Typography sx={pdfContainerSx?.tableHeadText}>
                        {date}
                      </Typography>
                    </TableCell>
                  </TableRow>
                </thead>
                <tbody>
                  {filteredAuditSiteDetails?.map((row, index) => (
                    <React.Fragment key={index}>
                      <RowPdf
                        key={index}
                        index={index}
                        row={row}
                        subscriptionDetails={subscriptionDetails}
                        listViewUrl={listViewUrl}
                        indiVidualScan={false}
                        reportMetaData={reportMetaData}
                      />
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
        {compareDate !== 0 && (
          <div
            style={{
              textAlign: 'center',
              ...pdfContainerSx?.compareDateBoxSx
            }}
          >
            <p style={pdfContainerSx?.compareDateTextSx}>
              {` ${timeConverter(
                currentDate,
                userDetails?.date_format ||
                  reportMetaData?.dateFormat ||
                  'DD/MM/YYYY',
                true,
                true
              )}`}
              {' vs '}
              {timeConverter(
                compareDate,
                userDetails?.date_format ||
                  reportMetaData?.dateFormat ||
                  'DD/MM/YYYY',
                true,
                true
              )}
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default FifthCardScannedPagesPDF;
